import {useState, useRef, useEffect} from 'react';
import {
    Box,
    Card,
    Button,
	Typography
} from '@mui/material';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import VideoThumbnail from '../assets/Brainsprays Letters Thumbnail.png';
import Mic from '@mui/icons-material/Mic';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import {b, c, e, j} from '../assets/videos';
import styled from 'styled-components';
import useSpeechToText from 'react-hook-speech-to-text';
import { VerticalSpace } from '../components';
import useRecorder from '../utilities/useRecorder';
import axios from 'axios';
import {toast} from 'react-toastify';
import moment from 'moment';

const VideoPlayer = styled.video`
    width: 70vw;
    min-width: 350px;
    height: auto;
	box-shadow: 0px 10px 10px 0px rgba(51,51,51,0.2);
`;

const VideoObject = {
	b: {
		video: b,
		pauseAt: 19.2,
		endAt: 32
	},
	c: {
		video: c,
		pauseAt: 19.0,
		endAt: 32
	},
	e: {
		video: e,
		pauseAt: 19.1,
		endAt: 32
	},
	j: {
		video: j,
		pauseAt: 19.2,
		endAt: 32
	},
}

const Letters = () => {
	const navigate = useNavigate();
    const {letter} = useParams();
	const [searchParams, setSearchParams] = useSearchParams()
    const playerRef = useRef(null);
    const [video, setVideo] = useState(VideoObject[letter])
    const [isVideoStarted, setIsVideoStarted] = useState(false)
    const [audioURL, isVoiceRecording, startRecording, stopRecording] = useRecorder({audio: true});
    const {
	    error,
	    isRecording,
	    interimResult,
	    results,
	    setResults,
	    startSpeechToText,
	    stopSpeechToText,
	  } = useSpeechToText({
	    // continuous: false,
	    continuous: true,
	    crossBrowser: true,
	    // googleApiKey: "AIzaSyBgItgnqpBRRFpdZ_tQRQW3D9EvIl0emUE",
		googleApiKey: "AIzaSyAMRLTHKYzxjs2dWJofWlLbpRO1vIgTMOU",
	    googleCloudRecognitionConfig: {
	      languageCode: 'en-US'
	    },
	    useLegacyResults: false,
	    // timeout: 3000
	});

	const submitAssessment = async (link) => {
		try {
			const {data} = await axios.post(
				'https://dapp-backend.triadkube.com/auth/create-assessment',
				{
					kid: searchParams.get('kid'),
					link,
					platform: 'letters',
					module: letter,
					answerTimestamp: video.pauseAt,
					answer: results[0].transcript,
					createdOn: moment.utc()
				}
			)

			const pptData = await axios.get(`https://saevz6t4g2.execute-api.ap-south-1.amazonaws.com/v001/pptx?id=${data.result._id}&collections=assessments`)
			toast.dismiss()
			toast.success(
				"Successfully saved your response. Redirecting to dashboard...",
				{
					onClose: () => navigate('/dashboard')
				}
			)
		} catch (error) {
			toast.dismiss()
			toast.error("Something went wrong when saving your assessment")
		}
	}

    const onStart = () => {
        setIsVideoStarted(true)
        startRecording()
        playerRef.current.play()
    }

    const onCurrentTimeUpdate = (currentTime) => {
		if(video.endAt <= currentTime && results.length) {
			stopRecording()
		}

		if(video.pauseAt <= currentTime && !isRecording && !results.length) {
		// if(video.pauseAt <= currentTime) {
			playerRef.current.pause()
			startSpeechToText()
		}
	}

	useEffect(() => {
		if(audioURL && !audioURL.includes('blob:'))
			submitAssessment(audioURL)
	}, [audioURL])

    useEffect(() => {
		if(playerRef?.current) {
			playerRef.current.src = video.video;
			playerRef.current.load()
		}
	}, [playerRef])

    useEffect(() => {
        if(results.length) {
            // stopRecording()
            stopSpeechToText()
            // setResults([])
            playerRef.current.play()
        }
    }, [results])

    return (
        <Box>
			<Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.3s ease', opacity: isRecording?1:0}} >
				<Mic sx={{color: '#2196F3', fontSize: '36px',}} />
				<Typography variant='subtitle1' >Speak out the answer 🗣️ Waiting for your response...</Typography>
			</Box>
			<VerticalSpace count={2} />
			<Box sx={{ position: 'relative' }} >
				<img src={VideoThumbnail} alt="Thumbnail" style={{position: 'absolute', width: '100%', height: '100%', opacity: isVideoStarted?'0':'1', transition: 'all 0.3s ease'}}/>
				<VideoPlayer autoPlay={false} controls={0} ref={playerRef} onTimeUpdate={evt => onCurrentTimeUpdate(evt.target.currentTime)} />
			</Box>
			<VerticalSpace count={2} />
			{
				!isVideoStarted
				?
				<Button variant='contained' onClick={onStart} sx={{fontSize:'2rem'}}>Start</Button>
				:
				null
			}
        </Box>
    )
}

export default Letters;